import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiUrl } from '@telespot/shared/environment';
import { LoggerService } from '@telespot/shared/logger/feature/util';
import { IFileUploader } from '@shared/use-cases';

interface IUploadResponse {
  file: string;
  links: {
    upload: {
      href: string;
    };
  };
}

export class HttpFileUploaderStorage implements IFileUploader {
  constructor(private _http: HttpClient, private _logger: LoggerService) {}

  async upload(file: File, endpoint: 'files' | 'support-files'): Promise<string> {
    this._logger.info(`[uploader-service] Uploading file ${file?.name} to /${endpoint}...`);
    try {
      const response = await this._http
        .post<IUploadResponse>(`${apiUrl()}/${endpoint}/`, { file: file.name })
        .toPromise();
      try {
        await this._http
          .put(response.links.upload.href, file, { headers: new HttpHeaders().set('If-None-Match', '*') })
          .toPromise();
        return Promise.resolve(response.file);
      } catch (initError: unknown) {
        const error = initError as Error;
        this._logger.fatal(`[uploader-service] Could not upload file: ${error.message}`, error);
        throw initError;
      }
    } catch (uploadError: unknown) {
      const error = uploadError as Error;
      this._logger.fatal(`[uploader-service] Could not initiate upload: ${error.message}`, error);
      throw uploadError;
    }
  }
}
